import React, {useEffect, useState, Fragment} from "react";

import {getUserDetails} from "../../DataFunctions/UserDataFns";
import {getDataFromResponse} from "../../DataFunctions/BaseDataFns";
import phpVars from 'phpVars';
import useModalChangePassword from "root/Modals/ChangePassword/useModalChangePassword";
import useModalAddUser from "root/Modals/AddUser/useModalAddUser";
import {getDocumentUrl} from "root/DataFunctions/CommonDataFns";

import {UserTypes} from "../../DataFunctions/Constants";
import {useGlobalContext} from "root/contexts/GlobalContext";
const WieldySidebarMyAccount = (props) =>
{
    const [data, setData] = useState({ isLoading: true, data: [] });

    const { user_name, userType } = useGlobalContext() ;

    const [renderChangePasswordModal, showChangePasswordModal] = useModalChangePassword(null,(result) =>
    {
    })

    const [renderAddUserModal, showAddUserModal] = useModalAddUser((result) =>
    {
        if (result === 'saved')
        {
            location.replace(location.pathname);
        }
    })

    const getUserImage = () =>
    {
        let url = '';

        //get the image if data is loaded
        if (data.data.document_id == null)
        {
            url = '/images/defaultPerson.jpg';
        } else
        {
            url = getDocumentUrl(data.data.document_id);
        }

        return url
    }

    const clickHandler = (event, mode) =>
    {
        event.preventDefault();

        switch (mode){
            case 'account':
                showAddUserModal(phpVars.user_id, 'edit', null, true);
                break;
            case 'password':
                showChangePasswordModal(phpVars.user_id);
                break;
        }
    }

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        getUserDetails(phpVars.user_id, null,(response) =>
        {
            setData({ isLoading: false, data: getDataFromResponse(response)[0] });
        });
    };

    const { logout_script } = phpVars ;

    return (
        <Fragment>
            <div className="dropdown mb-6" id="user-menu-dropdown">

                <a href="#" className="dropdown-toggle dt-avatar-wrapper text-body"
                   data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <img className="dt-avatar" src={getUserImage()} alt=""/>
                    <span className="dt-avatar-info">
                    <span className="dt-avatar-name">{user_name}</span>
                </span>
                </a>

                <div className="dropdown-menu dropdown-menu-right">
                    <div className="dt-avatar-wrapper flex-nowrap p-6 mt--5 bg-gradient-purple text-white rounded-top">
                        <img className="dt-avatar" src={getUserImage()}  alt=""/>
                        <span className="dt-avatar-info">
                        <span className="dt-avatar-name">{user_name}</span>
                        <span className="f-12">{data.data.typeName}</span>
                    </span>
                    </div>
                    { userType !== UserTypes.CHILD && <a href='' className="dropdown-item" onClick={(event) => clickHandler(event,'account')}> <i className="icon icon-user-o icon-fw mr-2 mr-sm-1" />Account</a>}
                    <a href='' className="dropdown-item" onClick={(event) => clickHandler(event,'password')}> <i className="icon icon-setting icon-fw mr-2 mr-sm-1" />Change Password </a>
                    <a className="dropdown-item" href={logout_script}> <i className="icon icon-edit icon-fw mr-2 mr-sm-1"/>Logout</a>
                </div>

            </div>

            {renderAddUserModal(props)}
            {renderChangePasswordModal(props)}
        </Fragment>
    )
}

export default WieldySidebarMyAccount;
